import { Instalacion } from './instalacion';

/**
 * Modalidad de reserva de una instalacion, derivada de su campo `tipo_reserva`:
 *   E = estancia por noches | H = por horas | D = pase de dia
 *
 * Unica fuente de verdad para la ruta de reserva y la unidad de precio.
 * Anadir una instalacion nueva de un tipo ya existente no requiere tocar codigo.
 */
export type TipoReserva = 'E' | 'H' | 'D';

export interface Modalidad {
    ruta: string;
    unidadPrecio: string;
}

export const MODALIDADES: Record<TipoReserva, Modalidad> = {
    E: { ruta: '/reserva-dias', unidadPrecio: '€/noche' },
    H: { ruta: '/reserva-horas', unidadPrecio: '€/hora' },
    D: { ruta: '/seleccionar-dia', unidadPrecio: '€' },
};

export function modalidadDe(instalacion: Instalacion): Modalidad | undefined {
    return MODALIDADES[instalacion.tipo_reserva as TipoReserva];
}
